import { createSelector } from 'reselect'
import { RootStoreState } from '@models/app.types.ts'

export const noraStateSelector = (state: RootStoreState) => state.nora

export const recentConversationsSelector = createSelector(
  noraStateSelector,
  (noraStore) => noraStore.recentConversations,
)

export const conversationsListSelector = createSelector(
  noraStateSelector,
  (noraStore) => noraStore.conversationsList,
)

export const pinnedConversationsSelector = createSelector(
  noraStateSelector,
  (noraStore) => noraStore.pinnedConversations,
)

export const pinnedConversationsCountSelector = createSelector(
  noraStateSelector,
  (noraStore) => noraStore.pinnedConversationsCount,
)

export const chatbotQuickPromptsSelector = createSelector(
  noraStateSelector,
  (noraStore) => noraStore.chatbotQuickPrompts,
)

export const healthDataReportsSelector = createSelector(
  noraStateSelector,
  (noraStore) => noraStore.healthDataReports,
)

export const chatbotReportsEligibleSelector = createSelector(
  noraStateSelector,
  (noraStore) => noraStore.chatbotReportsEligible,
)

export const chatbotSettingsSelector = createSelector(
  noraStateSelector,
  (noraStore) => noraStore.chatbotSettings,
)
